export default __webpack_public_path__ + "static/yoga-34eff25fc14dbe35a937a5712d5d0111.png";